import { Company, areCompanyRequiredFieldsFilled } from './Company';
import {
  Contact,
  ContactType,
  EDITABLE_CONTACT_TYPES,
  ContactsGroupedByContactTypes,
  groupContactsByContactTypes,
  areContactRequiredFieldsFilled
} from './Contact';

export function isCompanyWizardStepFilled(company: Company): boolean {
  return areCompanyRequiredFieldsFilled(company);
}

export function isContactsWizardStepFilled(contacts: Contact[]): boolean {
  const contactTypes: ContactType[] = EDITABLE_CONTACT_TYPES;
  const contactsGroupedByContactType: ContactsGroupedByContactTypes = groupContactsByContactTypes(
    contacts,
    contactTypes
  );
  return contactTypes
    .reduce((result: boolean, contactType: ContactType) => {
      const hasContactFilled: boolean = contactsGroupedByContactType[contactType]
        .some((contact: Contact): boolean => areContactRequiredFieldsFilled(contact));

      return result && hasContactFilled;
    }, true);
}

export function getCompanyWizardStepValue(company: Company): Company {
  return {
    officialName: company.officialName,
    country: company.country,
    state: company.state,
    zipCode: company.zipCode
  };
}

export function getContactsWizardStepValue(contacts: Contact[]): Contact[] {
  const contactTypes: ContactType[] = EDITABLE_CONTACT_TYPES;
  const contactsByContactTypes: ContactsGroupedByContactTypes = groupContactsByContactTypes(contacts, contactTypes);

  return contactTypes.reduce((result: Contact[], contactType: ContactType) => {
    if (contactsByContactTypes[contactType][0]) {
      result.push(contactsByContactTypes[contactType][0]);
    }
    return result;
  }, []);
}
